import { Text } from "flicket-ui";
import PriceOrFree from "../../common/PriceOrFree";
import { PriceInfoProps } from "../types";
import { useEffect, useState } from "react";

/**
 * Component to display price information based on current state
 */
export const PriceInfo = ({
  isExchangeFlow,
  ticketsLoading,
  hasSelection,
  cart,
  ownedTicketsExchangeValue,
  showFees,
}: PriceInfoProps) => {
  // Local state to track the final price
  const [finalPrice, setFinalPrice] = useState(0);

  // Update the final price whenever any of the dependencies change
  useEffect(() => {
    if (hasSelection) {
      // For all purchase types, simply use the cart total which already has the correct calculations
      if (
        cart.ticketTotal !== undefined &&
        cart.ticketTotal < ownedTicketsExchangeValue
      ) {
        // If the ticket total is less than the exchange value, set the final price to 0 which will show as "free"
        setFinalPrice(0);
      } else {
        setFinalPrice(cart.total);
      }
    } else {
      setFinalPrice(0);
    }
  }, [
    cart.total,
    cart.fees,
    cart.smsConfirmationFee,
    cart.defaultTransactionFee,
    isExchangeFlow,
    ownedTicketsExchangeValue,
    hasSelection,
  ]);

  // Handle loading state for ticket exchanges
  if (isExchangeFlow && ticketsLoading) {
    return (
      <Text variant="header.S" color="N400">
        Calculating price...
      </Text>
    );
  }

  // Handle selected state
  if (hasSelection) {
    return (
      <>
        <Text variant="header.S">
          <PriceOrFree price={finalPrice} />
        </Text>
        {showFees && finalPrice > 0 && (
          <Text variant="small">Including fees</Text>
        )}
      </>
    );
  }

  // Handle no selection state
  return (
    <Text variant="header.S" color="N400">
      Select tickets
    </Text>
  );
};
